import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-error-banner',
    templateUrl: './error-banner.component.html',
    standalone: false
})
export class ErrorBannerComponent {
  @Input() title: string = '';
  @Input() message: string = '';
}